/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billingoverviewfreehint3Inputs */

const en_billingoverviewfreehint3 = /** @type {(inputs: Billingoverviewfreehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a plan below.`)
};

const de_billingoverviewfreehint3 = /** @type {(inputs: Billingoverviewfreehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle unten einen Plan.`)
};

/**
* | output |
* | --- |
* | "Pick a plan below." |
*
* @param {Billingoverviewfreehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const billingoverviewfreehint3 = /** @type {((inputs?: Billingoverviewfreehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billingoverviewfreehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billingoverviewfreehint3(inputs)
	return de_billingoverviewfreehint3(inputs)
});
export { billingoverviewfreehint3 as "billingOverviewFreeHint" }